import React from 'react';
import { Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import { TopToolbar } from '~/UIKit/TopToolbar';
import { BackButton } from '~/Components';
import { Route } from '~/Constants/Routes.constants';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  IPrivateLayoutTitleWithAction,
  PrivateLayoutTitleWithAction,
} from './PrivateLayoutTitleWithAction';
import { PrivateLayoutOptions } from '../PrivateLayout';
import { PrivateLayoutTitleStyles } from './PrivateLayoutTitle.styles';
import { PrivateLayoutTitleActions } from './PrivateLayoutTitleActions';

const { HOME } = Route;

interface IPrivateLayoutTitleProps {
  title?: string | IPrivateLayoutTitleWithAction;
  actionDisabled?: boolean;
  backRoute?: string;
  hideBackButton?: boolean;
  actionName?: string;
  onActionTaken?: () => void;
  cancelInsteadOfBack?: boolean;
  options?: PrivateLayoutOptions[];
  secondaryAction?: JSX.Element | null;
  disableMobile?: boolean;
}

export const PrivateLayoutTitle = ({
  hideBackButton,
  title,
  actionName,
  onActionTaken,
  actionDisabled,
  backRoute,
  cancelInsteadOfBack,
  options,
  secondaryAction,
  disableMobile = false,
}: IPrivateLayoutTitleProps) => {
  const { t } = useTranslation();
  const { classes } = PrivateLayoutTitleStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobile = disableMobile ? false : isMobile;
  return (
    <>
      <Container
        maxWidth="md"
        className={classNames(classes.titleContainer, {
          [classes.navbarTitle]: !!actionName || options,
        })}
      >
        {!mobile && !hideBackButton && (
          <BackButton
            to={backRoute || HOME}
            text={cancelInsteadOfBack ? t('app.cancel') : undefined}
            slim
          />
        )}
        <div className={classes.titleWrapper}>
          {!!title &&
            (mobile && (!!actionName || options) ? (
              <TopToolbar
                title={title}
                action={actionName}
                onActionTaken={onActionTaken}
                actionDisabled={actionDisabled}
                backRoute={backRoute}
                hideBackButton={hideBackButton}
                cancelInsteadOfBack={cancelInsteadOfBack}
                options={options}
              />
            ) : (
              <Typography className={classes.title} variant="h1">
                {typeof title === 'string' ? (
                  title
                ) : (
                  <PrivateLayoutTitleWithAction {...title} actionDisabled={actionDisabled} />
                )}
              </Typography>
            ))}
          <PrivateLayoutTitleActions
            actionName={actionName}
            options={options}
            actionDisabled={actionDisabled}
            onActionTaken={onActionTaken}
            secondaryAction={secondaryAction}
          />
        </div>
      </Container>
    </>
  );
};
